module.exports = __webpack_public_path__ + "static/img/color.ae670eac.png";